import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const DidTakeFurtherBorrowing = ({
  onSelectAnswer,
  backClick,
  setStrugleRepaymentsBck,
  clsName,
  removeFromPending,
  prevQuestion,
  btnDisable = false,
}) => {
  const handleBack = () => {
    if (prevQuestion) {
      prevQuestion("didTakeFurtherBorrowing");
    } else if (backClick) {
      backClick();
    }
  };

  const optionHandle = async (e) => {
    setStrugleRepaymentsBck(e.target.value);
    if (e.target.value === "312") {
      onSelectAnswer(e);
    } else if (e.target.value === "313") {
      onSelectAnswer(e);
      removeFromPending("furtherBorrowing");
    }
  };
  return (
    <div className={`qsSlider slidea5 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        {" "}
        Did you take out further borrowing so that you could manage your
        finances?
      </h2>
      <ul className="btn-option optinal-items  two-options  slide-up-now">
        <li>
          <div className=" option_but ">
            <RadioButtonQuest
              key="didtake1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="312"
              name="didTakeFurtherBorrowing"
              id="didtake1"
              dataQuestId={111}
              dataAnsId={312}
              dataAnsLabel="Yes"
            />
          </div>
        </li>
        <li>
          <div className="option_but btn-next ">
            <RadioButtonQuest
              key="didtake2"
              className="radio"
              labelName="No"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="313"
              name="didTakeFurtherBorrowing"
              id="didtake2"
              dataQuestId={111}
              dataAnsId={313}
              dataAnsLabel="No"
            />
          </div>
        </li>
      </ul>
      <div className="mt-2 mb-4 text-center">
        <div>
          {" "}
          <button
            className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
            type="button"
            onClick={handleBack}
            disabled={btnDisable}
          >
            Back
          </button>{" "}
        </div>
      </div>
    </div>
  );
};

export default DidTakeFurtherBorrowing;
